/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: "/clientes",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "clientes_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "clientes", to: "clientes_list" }],
          permission: "cliente:view",
          title: "Clientes",
        },
      },
      {
        name: "clientes_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "clientes", to: "clientes_list" }],
          permission: "cliente:create",
          title: "Clientes - Cadastro",
        },
      },
      {
        name: "clientes_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "clientes", to: "clientes_list" }],
          permission: "cliente:edit",
          title: "Clientes - Edição",
        },
      },
    ],
  },
];
